//====================================================
//  Function: Copy text
//====================================================
function componentCopyText() {
  if ($('.js-copy-text').length) {
    $('.js-copy-text').click(function () {
      // var copyText = $(this)
      var copyTextValue = $('#main-copy').text()
      navigator.clipboard.writeText(copyTextValue)
    })
  }
}
